module.exports = __webpack_public_path__ + "static/media/vnpt.d57fc0d2.svg";